var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0998 12.33L3.07978 11.34C3.38978 11.02 3.56977 10.61 3.56977 10.16V6.26C3.56977 5.13 4.05986 4.05 4.91986 3.3C5.77986 2.54 6.87985 2.21 8.02985 2.36C9.96985 2.62 11.4299 4.37 11.4299 6.44V10.16C11.4299 10.61 11.6099 11.02 11.9199 11.34L12.8998 12.33H2.0998ZM9.16986 14.28C9.16986 15.03 8.39982 15.66 7.49982 15.66C6.59982 15.66 5.82978 15.03 5.82978 14.28V14H9.16986V14.28ZM14.5998 11.67L13.0998 10.17V6.45C13.0998 3.55 11.0098 1.09 8.24982 0.72C6.64982 0.51 5.02977 1 3.81977 2.06C2.59977 3.13 1.89984 4.67 1.89984 6.28V10.18L0.399844 11.68C0.00984421 12.07 -0.110205 12.65 0.0997954 13.16C0.319795 13.67 0.809805 14 1.35981 14H4.16986V14.28C4.16986 15.96 5.65982 17.33 7.49982 17.33C9.33982 17.33 10.8298 15.96 10.8298 14.28V14H13.6398C14.1898 14 14.6798 13.67 14.8898 13.16C15.1098 12.65 14.9898 12.06 14.5998 11.67Z",
    fill: "#BCBAC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bellIcon.dbbbcb2f534c022a716a76b7d6d304ec.svg";
export { ForwardRef as ReactComponent };